module.exports = __webpack_public_path__ + "img/Arrow.74090ecf.svg";